import type { IntlShape } from '@atlassian/jira-intl';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import type { RankIssueErrorPayload } from '@atlassian/jira-business-list-handlers/src/controllers/rank-issue/types.tsx';
import messages from './messages.tsx';

export const getRankItemFailGenericFlagWithWorkType = (
	intl: IntlShape,
	{ issueKey, workType }: RankIssueErrorPayload,
): FlagConfiguration => {
	return {
		type: 'error',
		title: intl.formatMessage(messages.rankItemErrorTitleIssueTerminologyRefreshM4, {
			issueKey,
			workType,
		}),
		description: messages.rankItemErrorDescription,
		messageId:
			'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag',
		messageType: 'transactional',
	};
};

export const getRankItemFail404FlagWithWorkType = (
	intl: IntlShape,
	{ issueKey, workType }: RankIssueErrorPayload,
): FlagConfiguration => {
	return {
		type: 'error',
		title: intl.formatMessage(messages.rankItemErrorTitleIssueTerminologyRefreshM4, {
			issueKey,
			workType,
		}),
		description: intl.formatMessage(messages.rankItem404ErrorDescriptionIssueTerminologyRefreshM4, {
			issueKey,
			workType,
		}),
		messageId:
			'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1',
		messageType: 'transactional',
	};
};

export const getRankItemFail403FlagWithWorkType = (
	intl: IntlShape,
	{ issueKey, workType }: RankIssueErrorPayload,
): FlagConfiguration => {
	return {
		type: 'error',
		title: intl.formatMessage(messages.rankItemErrorTitleIssueTerminologyRefreshM4, {
			issueKey,
			workType,
		}),
		description: messages.rankItem403ErrorDescriptionIssueTermRefresh,
		messageId:
			'business-list.controllers.use-rank-issue.flag.error.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag.1.1',
		messageType: 'transactional',
	};
};
